import { IFile } from '@sdk/contracts';

import { sdk } from '@/services';

const FileService = sdk.getService('FileService');

export const useFileService = () => {
  const getFileWithUrl = async (fileId: string): Promise<IFile | undefined> => {
    if (!fileId) return undefined;
    return FileService.getFileWithUrl(fileId);
  };

  return { getFileWithUrl };
};
